module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/1_7f36fd21357cec111396e32e78765f17.png";